
(function(){
  if(window.__ISWS10MAXLoaded) return;
  window.__ISWS10MAXLoaded = true;

  function reveal(root){
    var items=(root||document).querySelectorAll('.isw-s10__reveal:not([data-isw-init])');
    if(!('IntersectionObserver' in window)){
      items.forEach(function(el){el.classList.add('is-in');el.dataset.iswInit='1';});
      return;
    }
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){
          e.target.classList.add('is-in');
          e.target.dataset.iswInit='1';
          io.unobserve(e.target);
        }
      });
    },{threshold:.12});
    items.forEach(function(el){io.observe(el);});
  }

  function ranges(root){
    (root||document).querySelectorAll('[data-isw-range]:not([data-isw-init])').forEach(function(el){
      el.dataset.iswInit='1';
      var max=parseFloat(el.getAttribute('data-range-max')||'44');
      var count=el.querySelector('[data-isw-range-count]');
      function update(){
        var r=el.getBoundingClientRect();
        var p=Math.max(0,Math.min(1,(window.innerHeight-r.top)/(window.innerHeight+r.height*.35)));
        el.style.setProperty('--isw-route',(p*100)+'%');
        if(count) count.textContent=Math.round(max*p);
      }
      window.addEventListener('scroll',update,{passive:true});
      window.addEventListener('resize',update);
      update();
    });
  }

  function accordions(root){
    (root||document).querySelectorAll('[data-isw-accordion-btn]:not([data-isw-init])').forEach(function(btn){
      btn.dataset.iswInit='1';
      var item=btn.closest('[data-isw-accordion-item]');
      if(!item) return;
      btn.setAttribute('aria-expanded',item.classList.contains('is-open')?'true':'false');
      btn.addEventListener('click',function(){
        var open=item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded',open?'true':'false');
      });
    });
  }

  function heroParallax(root){
    if(!window.matchMedia('(hover:hover) and (pointer:fine)').matches) return;
    (root||document).querySelectorAll('[data-isw-hero]:not([data-isw-init])').forEach(function(hero){
      hero.dataset.iswInit='1';
      var product=hero.querySelector('.isw-s10-hero__product');
      if(!product) return;
      hero.addEventListener('pointermove',function(e){
        var r=hero.getBoundingClientRect();
        var x=((e.clientX-r.left)/r.width-.5)*14;
        var y=((e.clientY-r.top)/r.height-.5)*9;
        product.style.transform='translate('+x+'px,'+y+'px)';
      });
      hero.addEventListener('pointerleave',function(){product.style.transform='';});
    });
  }

  function ensureModal(){
    var modal=document.getElementById('isw-s10-modal');
    if(modal) return modal;
    modal=document.createElement('div');
    modal.id='isw-s10-modal';
    modal.className='isw-s10-modal';
    modal.setAttribute('aria-hidden','true');
    modal.innerHTML='<div class="isw-s10-modal__box" role="dialog" aria-modal="true" aria-label="S10MAX video"><button class="isw-s10-modal__close" type="button" aria-label="Close">×</button><div class="isw-s10-modal__media" data-isw-modal-media></div></div>';
    document.body.appendChild(modal);
    modal.querySelector('.isw-s10-modal__close').addEventListener('click',closeModal);
    modal.addEventListener('click',function(e){if(e.target===modal) closeModal();});
    return modal;
  }

  function closeModal(){
    var modal=document.getElementById('isw-s10-modal');
    if(!modal) return;
    var media=modal.querySelector('[data-isw-modal-media]');
    if(media) media.innerHTML='';
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden','true');
    document.documentElement.style.overflow=modal.getAttribute('data-prev-overflow')||'';
    modal.removeAttribute('data-prev-overflow');
  }

  function videos(root){
    (root||document).querySelectorAll('[data-isw-video]:not([data-isw-init])').forEach(function(card){
      card.dataset.iswInit='1';
      function open(){
        var youtube=card.getAttribute('data-youtube-id');
        var vimeo=card.getAttribute('data-vimeo-id');
        var local=card.getAttribute('data-local-video');
        var modal=ensureModal();
        var media=modal.querySelector('[data-isw-modal-media]');
        if(local){
          media.innerHTML='<video src="'+local+'" controls autoplay playsinline></video>';
        }else if(youtube){
          media.innerHTML='<iframe width="1280" height="720" style="position:absolute;inset:0;width:100%;height:100%;max-width:none;max-height:none;border:0;display:block" src="https://www.youtube.com/embed/'+youtube+'?autoplay=1&rel=0&playsinline=1" title="S10MAX video" allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowfullscreen></iframe>';
        }else if(vimeo){
          media.innerHTML='<iframe width="1280" height="720" style="position:absolute;inset:0;width:100%;height:100%;max-width:none;max-height:none;border:0;display:block" src="https://player.vimeo.com/video/'+vimeo+'?autoplay=1" title="S10MAX video" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>';
        }else{
          return;
        }
        modal.setAttribute('data-prev-overflow',document.documentElement.style.overflow||'');
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden','false');
        document.documentElement.style.overflow='hidden';
      }
      card.addEventListener('click',open);
      card.addEventListener('keydown',function(e){
        if(e.key==='Enter'||e.key===' '){e.preventDefault();open();}
      });
    });
  }

  function scrollBuy(root){
    (root||document).querySelectorAll('[data-isw-scroll-buy]:not([data-isw-init])').forEach(function(btn){
      btn.dataset.iswInit='1';
      btn.addEventListener('click',function(e){
        var form=document.querySelector('form[action*="/cart/add"]');
        if(form){
          e.preventDefault();
          form.scrollIntoView({behavior:'smooth',block:'center'});
        }
      });
    });
  }

  function init(root){
    reveal(root);
    ranges(root);
    accordions(root);
    heroParallax(root);
    videos(root);
    scrollBuy(root);
  }

  function boot(){init(document);}
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',boot,{once:true});
  }else{
    boot();
  }

  document.addEventListener('page:loaded',function(){init(document);});
  document.addEventListener('shopify:section:load',function(e){init(e.target);});
  document.addEventListener('shopify:block:select',function(e){
    var item=e.target.closest('[data-isw-accordion-item]');
    if(item){
      item.classList.add('is-open');
      var btn=item.querySelector('[data-isw-accordion-btn]');
      if(btn) btn.setAttribute('aria-expanded','true');
    }
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape') closeModal();});
})();
